import { render, staticRenderFns } from "./ChartUsaTopFiveTrusts.vue?vue&type=template&id=54788d79&"
import script from "./ChartUsaTopFiveTrusts.vue?vue&type=script&lang=js&"
export * from "./ChartUsaTopFiveTrusts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ChartUsaTopFiveTrusts.vue?vue&type=custom&index=0&blockType=tsv"
if (typeof block0 === 'function') block0(component)

export default component.exports